import React from 'react';
import Carousel from '@nerdwallet/react-carousel';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import SocialImpactCarouselTile from './socialimpact-carousel-tile';
import styles from './socialimpact-carousel.module.less';

const SocialImpactCarousel = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile) => (
    <SocialImpactCarouselTile {...tile} />
  ));
  return (
    <React.Fragment>
      <div
        className={classNames([
          classes('display-none--wide'),
          classes('display-block'),
        ])}
      >
        {/* Mobile */}
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          arrows={false}
          enableDotNavigation
          inactiveDotColor="#3D4045"
          activeDotColor="#3D4045"
          slidesToShow="1.4"
          dots
          dotsClass="slick-dots social-impact"
          className={styles.carouselContainer}
        >
          {renderedTiles}
        </Carousel>
      </div>
      <div
        className={classNames([
          classes('display-none'),
          classes('display-block--wide'),
        ])}
      >
        {/* Desktop */}
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#3D4045"
          activeDotColor="#3D4045"
          slidesToShow="3"
          className={styles.carouselContainer}
        >
          {renderedTiles}
        </Carousel>
      </div>
    </React.Fragment>
  );
};

SocialImpactCarousel.propTypes = {
  tiles: PropTypes.object,
};

SocialImpactCarousel.displayName = 'Social Impact Carousel';
SocialImpactCarousel.analyticsName = 'social_impact_carousel';

export default SocialImpactCarousel;
